import { Container } from "./styles";
import emailIcon from "../../assets/email-icon.svg";
import linkedin from "../../assets/linkedin.svg";
import githubIcon from "../../assets/github.svg";
import twitter from "../../assets/twitter.svg";
import hashnode from "../../assets/icons8-hashnode.svg";
import { Form } from "../Form/Form";
import ScrollAnimation from "react-animate-on-scroll";


export function Contact(){

  return(
    <Container id="contact">
      <header>
        <ScrollAnimation animateIn="fadeInUp">
          <h2>Let's Connect</h2>
          <p>Have a project in mind or want to collaborate? Feel free to reach out!</p>
        </ScrollAnimation>
      </header>
      
      <div className="contact-wrapper">
        <ScrollAnimation animateIn="fadeInLeft" className="contact-info">
          <div className="info-card">
            <div className="info-header">
              <span className="icon-wrapper">
                <span className="pulse"></span>
                ✉️
              </span>
              <h3>Get In Touch</h3>
            </div>
            
            <div className="contact-item">
              <img src={emailIcon} alt="Email" />
              <div className="contact-text">
                <span className="label">Email</span>
                <a href="mailto:kamalkirti16@gmail.com">kamalkirti16@gmail.com</a>
              </div>
            </div>

            <div className="divider"></div>

            <div className="social-section">
              <h4>Connect with me</h4>
              <div className="social-links">
                <a href="https://www.linkedin.com/in/kirtikamal/" target="_blank" rel="noreferrer" className="social-link linkedin">
                  <img src={linkedin} alt="LinkedIn" />
                </a>
                <a href="https://github.com/kirtikamal/" target="_blank" rel="noreferrer" className="social-link github">
                  <img src={githubIcon} alt="GitHub" />
                </a>
                <a href="https://twitter.com/KirtiKamal12" target="_blank" rel="noreferrer" className="social-link twitter">
                  <img src={twitter} alt="Twitter" />
                </a>
                <a href="https://decodedevs.hashnode.dev/" target="_blank" rel="noreferrer" className="social-link hashnode">
                  <img src={hashnode} alt="Hashnode" />
                </a>
              </div>
            </div>

            <div className="availability">
              <span className="status-dot"></span>
              <span>Always open to connect & collaborate on exciting projects</span>
            </div>
          </div>
        </ScrollAnimation>

        <ScrollAnimation animateIn="fadeInRight" className="form-section">
          <Form />
        </ScrollAnimation>
      </div>
    </Container>
  )
}